import { supabase } from "../lib/supabase";
import { SupabaseUser } from "../types/supabase";
import { BaseApi } from "./baseApi";

// TODO: Move to shared
type SupabaseMentor = {
  uuid: string;
  userUuid: string;
  specialization: string;
  meetingsHeld: number;
  googleCalenderToken: string;
};
class UserApi extends BaseApi<SupabaseUser> {
  async getById(id: string): Promise<SupabaseUser | null> {
    const { data, error } = await supabase
      .from("vincer_base_user")
      .select(
        `
        uuid,
        name,
        email,
        date_joined,
        company,
        job_title,
        user_roles:user_roles (
          role_name
        )
      `
      )
      .eq("uuid", id)
      .maybeSingle();
    if (error) throw error;
    if (!data) return null;

    // Map user_roles to roles array
    const roles = Array.isArray(data.user_roles)
      ? data.user_roles.map((r: { role_name: string }) => r.role_name)
      : [];

    return {
      uuid: data.uuid,
      name: data.name,
      email: data.email,
      dateJoined: data.date_joined,
      isMentor: roles.includes("MENTOR"),
      roles,
      company: data.company,
      jobTitle: data.job_title,
    };
  }
  async getMentorRecord(userUuid: string): Promise<SupabaseMentor | null> {
    const { data, error } = await supabase
      .from("mentor")
      .select(
        "uuid, user_uuid, specialization, meetings_held, google_calender_token"
      )
      .eq("user_uuid", userUuid)
      .maybeSingle();
    if (error) throw error;
    if (!data) return null;
    return {
      uuid: data.uuid,
      userUuid: data.user_uuid,
      specialization: data.specialization,
      meetingsHeld: data.meetings_held,
      googleCalenderToken: data.google_calender_token,
    };
  }
}

export const userApi = new UserApi("vincer_base_user");
